import React from 'react';
import { CheckCircle, BookOpen, FileText, Video } from 'lucide-react';
import { Card } from '../ui/Card';
export function WhatYouGet() {
  return <section className="py-20 bg-white" data-id="element-201">
      <div className="container mx-auto px-4" data-id="element-202">
        <div className="text-center mb-16" data-id="element-203">
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-204">
            Esto es lo que recibes hoy
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-205">
            No es solo información. Es un kit de supervivencia legal completo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto items-center" data-id="element-206">
          <div className="relative" data-id="element-207">
            <div className="absolute inset-0 bg-gradient-to-tr from-amber-200 to-red-200 rounded-full blur-3xl opacity-30" data-id="element-208"></div>
            <img src="https://cdn.magicpatterns.com/uploads/bEAsB9KBqc99JVjaj8k6io/heylloyd-image-1771906723527.png" alt="Kit Completo" className="relative z-10 w-full rounded-xl shadow-2xl transform rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-209" />
          </div>

          <div className="space-y-6" data-id="element-210">
            <Card className="p-6 border-l-4 border-l-amber-500" data-id="element-211">
              <div className="flex gap-4" data-id="element-212">
                <BookOpen className="w-8 h-8 text-amber-500 flex-shrink-0" data-id="element-213" />
                <div data-id="element-214">
                  <h3 className="font-bold text-lg text-slate-900" data-id="element-215">
                    Guía Maestra "El Protocolo Sombrilla"
                  </h3>
                  <p className="text-slate-600 text-sm mt-1" data-id="element-216">
                    Manual paso a paso para blindar tu vida en EE. UU. (Valor:
                    $97)
                  </p>
                </div>
              </div>
            </Card>

            <Card className="p-6 border-l-4 border-l-blue-500" data-id="element-217">
              <div className="flex gap-4" data-id="element-218">
                <FileText className="w-8 h-8 text-blue-500 flex-shrink-0" data-id="element-219" />
                <div data-id="element-220">
                  <h3 className="font-bold text-lg text-slate-900" data-id="element-221">
                    Plantillas Legales Editables
                  </h3>
                  <p className="text-slate-600 text-sm mt-1" data-id="element-222">
                    Cartas de poder y custodia temporal listas para llenar.
                    (Valor: $250)
                  </p>
                </div>
              </div>
            </Card>

            <Card className="p-6 border-l-4 border-l-red-500" data-id="element-223">
              <div className="flex gap-4" data-id="element-224">
                <Video className="w-8 h-8 text-red-500 flex-shrink-0" data-id="element-225" />
                <div data-id="element-226">
                  <h3 className="font-bold text-lg text-slate-900" data-id="element-227">
                    Video-Tutorial "La Carpeta Roja"
                  </h3>
                  <p className="text-slate-600 text-sm mt-1" data-id="element-228">
                    Cómo organizar tus documentos para que sean efectivos en una
                    emergencia. (Valor: $47)
                  </p>
                </div>
              </div>
            </Card>

            <div className="mt-8 pt-8 border-t border-slate-100" data-id="element-229">
              <h4 className="font-bold text-slate-900 mb-4" data-id="element-230">
                También incluye estos Bonos Exclusivos:
              </h4>
              <ul className="space-y-3" data-id="element-231">
                <li className="flex items-center gap-2 text-slate-700" data-id="element-232">
                  <CheckCircle className="w-5 h-5 text-green-500" data-id="element-233" />
                  <span data-id="element-234">Checklist de Emergencia de 72 Horas</span>
                </li>
                <li className="flex items-center gap-2 text-slate-700" data-id="element-235">
                  <CheckCircle className="w-5 h-5 text-green-500" data-id="element-236" />
                  <span data-id="element-237">
                    Guía: "Cómo hablar con tus hijos sobre esto sin asustarlos"
                  </span>
                </li>
                <li className="flex items-center gap-2 text-slate-700" data-id="element-238">
                  <CheckCircle className="w-5 h-5 text-green-500" data-id="element-239" />
                  <span data-id="element-240">
                    Directorio de Organizaciones de Ayuda Legal Gratuita
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}